import moment from "moment";
import {
  TITLE_AGUA_DULCE,
  TITLE_AGUA_MAR,
  TITLE_INSPECCION,
  TITLE_PROCESOS,
  TITLE_Administracion
} from "../constants/title-forms";
import Compressor from "compressorjs";

export const prepareText = text =>
  text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase();

export const extractInitials = text => {
  let result = "";
  const _text = text || "";
  const splitText = _text.split(" ");
  if (splitText.length > 1) {
    result += splitText[0].slice(0, 1);
    result += splitText[1].slice(0, 1);
  } else if (splitText.length === 1) {
    result += splitText[0].slice(0, 2);
  }
  return result.toUpperCase();
};

export const handleCleanTitle = (title, rol) => {
  const _rol = "- " + (rol || "");
  let _title = title || ""
  _title = _title.replace(TITLE_AGUA_DULCE, "");
  _title = _title.replace(TITLE_PROCESOS, "");
  _title = _title.replace(TITLE_AGUA_MAR, "");
  _title = _title.replace(TITLE_Administracion, "");
  _title = _title.replace(_rol, "");
  _title = _title.replace(TITLE_INSPECCION, "");
  return _title.trim();
};

export const fileToBase64 = file => {
  return new Promise((resolve, reject) => {
    const _file = new FileReader();
    _file.readAsDataURL(file);
    _file.onload = () => resolve(_file?.result);
    _file.onerror = err => reject(err);
  });
};

export const formatdate = date => moment(date).format("DD/MM/YYYY HH:mm:ss");

export const imageCompressor = file => {
  return new Promise(resolve => {
    console.log('[imageCompressor] Iniciando compresión de archivo:', file?.name || 'unknown', 'Tamaño original:', (file?.size / 1024 / 1024).toFixed(2), 'MB');

    if (file.type.indexOf("image") >= 0) {
      new Compressor(file, {
        quality: 0.4,
        maxWidth: 1920,
        maxHeight: 1440,
        success: fileOptimize => {
          const sizeInMB = (fileOptimize.size / 1024 / 1024).toFixed(2);
          console.log('[imageCompressor] ✓ Compresión exitosa, tamaño: ', sizeInMB, 'MB');
          resolve(fileOptimize);
        },
        error: (error) => {
          console.error('[imageCompressor] ✗ Error en compresión:', error);
          resolve(null);
        },
      });
    } else {
      console.error('[imageCompressor] ✗ Archivo no es imagen:', file.type);
      resolve(null);
    }
  });
};

export const base64ToBlob = base64 => {
  return new Promise(resolve => {
    console.log('[base64ToBlob] Iniciando conversión...');

    fetch(base64)
      .then(res => {
        console.log('[base64ToBlob] ✓ fetch exitoso, convertiendo a blob...');
        return res.blob();
      })
      .then(blob => {
        const sizeInMB = (blob.size / 1024 / 1024).toFixed(2);
        console.log('[base64ToBlob] ✓ Blob creado exitosamente (', sizeInMB, 'MB)');
        resolve(blob);
      })
      .catch((error) => {
        console.error('[base64ToBlob] ✗ Error en conversión:', error.message);
        resolve(null);
      });
  });
};

export const formateaRut = rut => {
  let rutPuntos = "";
  const actual = rut.replace(/^0+/, "");
  if (actual.length > 1) {
    const sinPuntos = actual.replace(/\./g, "");
    const actualLimpio = sinPuntos.replace(/-/g, "");
    const inicio = actualLimpio.substring(0, actualLimpio.length - 1);
    let i = 0;
    let j = 1;
    for (i = inicio.length - 1; i >= 0; i--) {
      const letra = inicio.charAt(i);
      rutPuntos = letra + rutPuntos;
      if (j % 3 == 0 && j <= inicio.length - 1) {
        rutPuntos = "." + rutPuntos;
      }
      j++;
    }
    const dv = actualLimpio.substring(actualLimpio.length - 1);
    rutPuntos = rutPuntos + "-" + dv;
  }
  return rutPuntos;
};
